<div class="flex ms-large-y top-container">
  <div class="ms-small-r search-container">
    <fcom-text-input
      #search
      [parentForm]="form"
      [controlName]="'search'"
      [displayMargin]="false"
      [placeHolder]="'CORPORATE.corporatePortal.filterUsers'"
      [hideLabel]="true"
      [disableAutoComplete]="true"
      [clearInput]="true"
    ></fcom-text-input>
  </div>
  <div class="role-container">
    <fin-select-input
      [parentForm]="form"
      [controlName]="'role'"
      [options]="roles"
      [disableLabel]="true"
      [displayMargin]="false"
      [selectLabelTranslationKey]="'CORPORATE.corporatePortal.addUser.fields.role.allRoles'"
      [translationPrefix]="'CORPORATE.corporatePortal.roles'"
    ></fin-select-input>
  </div>
  <div class="flex flex--end flex-1 button-container">
    <fcom-button
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      [text]="'CORPORATE.corporatePortal.addUserBtn' | finLocalization"
      [size]="ButtonSize.LARGE"
      [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
      (clickBtn)="addNewUser()"
    ></fcom-button>
  </div>
</div>
<ng-container *ngIf="rowData$ | async as rowData; else loader">
  <fcom-table
    class="user-list"
    [rowData]="rowData"
    [cellTemplate]="itemTemplate"
    [mobileTemplate]="mobileTemplate"
    [headers]="headers"
    [headerTemplate]="headerTemplate"
    [usePagination]="true"
    [itemsPerPageOptions]="[10, 20, 50, 100]"
    [caption]="'CORPORATE.corporatePortal.registeredUsers' | finLocalization"
    [noResultsMsg]="'CORPORATE.corporatePortal.noResults' | finLocalization: [search.control?.value]"
    (clickBtn)="handleRowClick($event)"
  ></fcom-table>
</ng-container>

<ng-template #headerTemplate let-item>
  <div class="font-body-2" *ngIf="item.key !== 'details'">
    {{ 'CORPORATE.corporatePortal.userDetailsRows.' + item.key | finLocalization }}
  </div>
</ng-template>
<ng-template #itemTemplate let-item>
  <div class="flex flex--row flex--top">
    <div class="flex-1">
      <div class="nordic-blue-900-text font-body-2">
        <ng-container [ngSwitch]="item.key">
          <fcom-icon *ngSwitchCase="'details'" class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_RIGHT"></fcom-icon>
          <span *ngSwitchCase="'role'">{{ 'CORPORATE.corporatePortal.roles.' + item.value | finLocalization }}</span>
          <span *ngSwitchDefault data-hj-suppress>{{ item.value }}</span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileTemplate let-item>
  <div class="flex font-body-2">
    <div class="flex-1" data-hj-suppress>
      <div class="bold-type">{{ item.name.data.value }}</div>
      <div>{{ item.phone.data.value }}</div>
    </div>
    <div class="flex flex--center">
      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_RIGHT"></fcom-icon>
    </div>
  </div>
</ng-template>

<ng-template #loader>
  <fcom-loader data-testid="corporate-user-list-loader" [loaderType]="LoaderTheme.INLINE"></fcom-loader>
</ng-template>
